import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { OrganisationDto, TenantDto } from '@careapp-group/ng-sdk-v2-new';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from '../../../store';
import * as actions from '../../../store/actions/index';
import * as selectors from '../../../store/reducers/index';

import { FormCoreComponent } from '../form-core';

@Component({
  selector: 'organisation-form',
  templateUrl: './organisation-form.component.html',
  styleUrls: ['./organisation-form.component.scss'],
})
export class OrganisationFormComponent
  extends FormCoreComponent<OrganisationDto>
  implements OnInit
{
  public tenants$: Observable<{ [id: string]: TenantDto }>;
  _readOnly = false;
  _tenantPreviouslySet = false;

  @Input() set readOnly(value: boolean) {
    if (value && value === true) {
      this.form.disable();
      this._readOnly = true;
    }
  }
  @Input()
  set organisation(value: OrganisationDto) {
    if (value) {
      const result = { ...value };
      result.address = result.address || {};
      this.form.patchValue(result || {}, { emitEvent: false, onlySelf: true });
      if (!!value.tenantId) {
        this._tenantPreviouslySet = true;
      }
    }
  }

  ngOnInit() {
    this.store.dispatch(actions.Tenants.RequestAllAction());
    this.tenants$ = this.store.select(selectors.getEntities(selectors.TENANTS));
  }

  constructor(private store: Store<State>) {
    super();
    this.form = new UntypedFormGroup({
      name: new UntypedFormControl('', Validators.required),
      enabled: new UntypedFormControl(true),
      contactNumber: new UntypedFormControl('', Validators.required),
      capacity: new UntypedFormControl(null),
      address: new UntypedFormGroup({
        address1: new UntypedFormControl('', Validators.required),
        address2: new UntypedFormControl(),
        town: new UntypedFormControl('', Validators.required),
        state: new UntypedFormControl('', Validators.required),
        postcode: new UntypedFormControl('', Validators.required),
        country: new UntypedFormControl('', Validators.required),
      }),
      tenantId: new UntypedFormControl(null),
    });
  }
}
